(function (fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function () {
    try {
        if (!window.matchMedia('(min-width: 768px)').matches) {
            const activeElement = document.querySelector('.bar .bar-menu a.active');
            const { parentElement } = activeElement;
            const offsetElement = parentElement.offsetLeft;

            const containerMenu = document.querySelector('nav.bar-nav');
            containerMenu.scrollLeft = offsetElement;
            return;
        }
        var bigBtn = document.querySelector('.rheader-free-trial .rheader-btn, .rheader-new-free-trial .rheader-new-btn');
        var smallBtn = document.querySelector('[data-elem="bar-free-trial-btn"]');
        var previousScrollPos = window.pageYOffset;
        var smallBtnTimeout, bigBtnTimeout;
        var breakPosition = Math.max(bigBtn.getBoundingClientRect().top + window.pageYOffset - 200, 1);

        bigBtn.classList.add('animation-forward');
        smallBtn.classList.add('animation-forward');

        if (window.pageYOffset > breakPosition) {
            smallBtn.classList.add('animated');
            smallBtn.classList.add('bounceIn');
            smallBtn.classList.remove('zoomOut');
            bigBtn.classList.add('animated');
            bigBtn.classList.add('zoomOut');
        } else {
            smallBtn.classList.add('animated');
            smallBtn.classList.add('zoomOut');
            bigBtn.classList.add('animated');
            bigBtn.classList.add('bounceIn');
        }

        window.requestAnimationFrame(animateButton);
    } catch (e) {
        smallBtn.classList.remove('animated');
        smallBtn.classList.remove('animation-forward');
        smallBtn.classList.remove('zoomOut');
        smallBtn.classList.remove('bounceIn');
        bigBtn.classList.remove('animated');
        bigBtn.classList.remove('animation-forward');
        bigBtn.classList.remove('zoomOut');
        bigBtn.classList.remove('bounceIn');
    }
    function animateButton() {
        var breakPosition = Math.max(bigBtn.getBoundingClientRect().top + window.pageYOffset - 200, 1);

        if (window.pageYOffset > breakPosition && previousScrollPos <= breakPosition) {
            clearTimeout(smallBtnTimeout);
            clearTimeout(bigBtnTimeout);
            animateFromBigToSmall();
            smallBtn.classList.remove('animation-forward');
            bigBtn.classList.remove('animation-forward');
        } else if (window.pageYOffset <= breakPosition && previousScrollPos > breakPosition) {
            clearTimeout(smallBtnTimeout);
            clearTimeout(bigBtnTimeout);
            animateFromSmallToBig();
            smallBtn.classList.remove('animation-forward');
            bigBtn.classList.remove('animation-forward');
        }
        previousScrollPos = window.pageYOffset;
        window.requestAnimationFrame(animateButton);
    }

    function animateFromBigToSmall() {
        bigBtn.classList.add('animated');
        bigBtn.classList.add('zoomOut');
        bigBtn.classList.remove('bounceIn');
        smallBtnTimeout = setTimeout(function () {
            smallBtn.classList.add('animated');
            smallBtn.classList.add('bounceIn');
            smallBtn.classList.remove('zoomOut');
        }, 150);
    }
    function animateFromSmallToBig() {
        smallBtn.classList.add('animated');
        smallBtn.classList.add('zoomOut');
        smallBtn.classList.remove('bounceIn');
        bigBtnTimeout = setTimeout(function () {
            bigBtn.classList.add('animated');
            bigBtn.classList.add('bounceIn');
            bigBtn.classList.remove('zoomOut');
        }, 150);
    }
});
